import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart, UpdateShoppingCart, GetSKUDetailGlb, formatDateMMDDYYYY } from "../../GlobalScript";
import { ShoppingCartContext } from '../ShoppingCartContext';
import Cookies from 'js-cookie';
import PaginationBar from '../../PaginationBar';
import Calendar from 'react-calendar';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import PulseLoader from "react-spinners/PulseLoader";
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import HistoryDetail from '../HistoryDetail';
import FooterDealer from '../../FooterDealer.js';
import { useTranslation } from 'react-i18next';
import "react-calendar/dist/Calendar.css";

export default function OrderHistory() {

    const navigate = useNavigate();
    const countPerPage = 25;
    const [pageResults, setPageResults] = useState(countPerPage);
    const [tempPage, setTempPage] = useState(countPerPage);
    const [resultsLength, setResultsLength] = useState(0);
    const [orderItems, setOrderItems] = useState([]);
    const [firstLoad, setFirstLoad] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const formatDate = (date) => {
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };
    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);
    const MIN_YEAR = 2000;
    const MAX_DATE = new Date();
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [dateFromInput, setDateFromInput] = useState('');
    const [dateToInput, setDateToInput] = useState('');
    const normalize = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const [showFromCal, setShowFromCal] = useState(false);
    const [showToCal, setShowToCal] = useState(false);

    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    /*const [itemOffset, setItemOffset] = useState(0);*/
    /*const endOffset = itemOffset + pageResults;*/
    /*const currentItems = orderItems.slice(itemOffset, endOffset);*/
    const currentItems = orderItems;
    const pageCount = Math.ceil(resultsLength / pageResults);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const historyType = 'order';
    const location = useLocation();
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [OrderStatusList, setOrderStatusList] = useState(false);
    const { shoppingCart, setShoppingCart, getCookie } = useContext(ShoppingCartContext);
    const [pop, setPop] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [errorModal, setErrorModal] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [currentPage, setCurrentPage] = useState(() => {
        const saved = localStorage.getItem("orderSearch");
        if (!saved) return 0;

        const parsed = JSON.parse(saved);
        return parsed.pagenum ? parsed.pagenum - 1 : 0;
    });
    const [errorMessage, setErrorMessage] = useState('');
    const [restoredSearch, setRestoredSearch] = useState(null);
    const [isConfirmationLink, setIsConfirmationLink] = useState(false);
    const { t } = useTranslation();
    const [searchType, setSearchType] = useState(1);
    const [invalidSearch, setInvalidSearch] = useState(false);
    const [returnableOrders, setReturnableOrders] = useState(new Map());
    const [initialLoad, setInitialLoad] = useState(true);
    const [lastUpdatedDate, setLastUpdatedDate] = useState(null);

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));
        if (userInfo?.loginType !== 5) {
            document.title = 'K-Dealer - Order Status';
        } else {
            document.title = `K-Countries - ${t("Navigation.Order History")}`;
        }
    }, []);

    useEffect(() => {
        try {
            const us = getCookie();
            if (!userInfo && us) {
                setUserInfo(us);
            }
            if (!userInfo) {
                window.GlobalLoading++;
            }
            if (window.GlobalLoading === 1) {
                window.location.reload();
            }
        } catch (e) {
            console.log(e);
        }
    }, [userInfo])

    const handleDetailsModalShow = async (order) => {
        handlePop();
        await GetOrderDetail(order);
        setShowDetailsModal(true);
    }

    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
        setSelectedOrder(null);
        if (location.state) {
            window.history.replaceState({}, '')
        }
    }

    useEffect(() => {
        if (showDetailsModal === true) {
            handleClosePop();
        }
    }, [showDetailsModal])

    const handleErrorModalShow = () => {
        setErrorModal(true);
    }

    const handleErrorModalHide = () => {
        setErrorMsg('');
        setErrorModal(false);
    }

    useEffect(() => {
        if (isConfirmationLink) return;
        const saved = localStorage.getItem("orderSearch");

        if (saved) {
            const parsed = JSON.parse(saved);
            setKeyword(parsed.keyword || "");
            setStatus(parsed.status || "");
            setDateFrom(parsed.dateFrom || "");
            setDateTo(parsed.dateTo || "");
            setDateFromInput(parsed.dateFromInput || "");
            setDateToInput(parsed.dateToInput || "");
            setPageResults(parsed.count || 25);
            setCurrentPage((parsed.pagenum || 1) - 1);

            setRestoredSearch(parsed);
        }
    }, [isConfirmationLink])

    useEffect(() => {
        if (!restoredSearch) return;
        if (isConfirmationLink) return;

        //Do not automatically search, just save search criteria

        //LoadOrders(restoredSearch.pagenum, "", false, {
        //    keyword: restoredSearch.keyword,
        //    status: restoredSearch.status,
        //    dateFrom: restoredSearch.dateFrom,
        //    dateTo: restoredSearch.dateTo,
        //    pageResults: restoredSearch.count
        //});
    }, [restoredSearch, isConfirmationLink])

    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            localStorage.removeItem("orderSearch");
            setIsConfirmationLink(true);
            setKeyword(location.state.id);
            setDateFrom('');
            setDateTo('');
            setDateFromInput('');
            setDateToInput('');
            setStatus('');
            setSearchType(2);
            LoadOrders(1, '', false);
        } else if (initialLoad === true) {
            handleSearchClick();
            setInitialLoad(false);
        }
    }, [location, initialLoad])

    //useEffect(() => {
    //    if (location.state && location.state.id && location.state.id !== '') {
    //        LoadOrders(1, '', false);
    //    }
    //}, [keyword])

    useEffect(() => {
        if (isConfirmationLink) {
            if (location.state && location.state.id && location.state.id !== '' && orderItems && orderItems.length > 0) {
                handleDetailsModalShow(orderItems[0]);
            }
        }
    }, [orderItems])

    const GetOrderDetail = async (order) => {
        CheckSession();
        const user = GetCoockie();
        const response = await fetch("kdealer/GetOrderDetail/" + (order.orderID === '' ? order.refID : order.orderID) + "/2/" + user.userKey + "/" + user.dealerID);
        if (response.status !== 200) {
            handleClosePop();
            setErrorMsg('There was an error while attempting to get the details of your order. Please try again later.')
            handleErrorModalShow();
            return;
        }
        const items = await response.json();
        const orderToShow = {
            order: order,
            orderDetail: items
        }
        setSelectedOrder(orderToShow);
        handleClosePop();
    }

    useEffect(() => {
        if (!OrderStatusList) {
            LoadOrderStatusList();
        }
    }, [OrderStatusList]);

    const ResetSearch = async () => {
        setKeyword('');
        setStatus('');
        setDateFrom('');
        setDateTo('');
        setDateFromInput('');
        setDateToInput('');
        setShowFromCal(false);
        setShowToCal(false);
        setPageResults(25);
        setCurrentPage(0);
        setErrorMessage('');
        localStorage.removeItem("orderSearch");
        setFirstLoad(true);
    }

    const LoadOrderStatusList = async () => {
        try {
            CheckSession();
            const response = await fetch("kdealer/GetOrderStatusList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setOrderStatusList(lst);
            console.log(lst)
        } catch (e) {
            console.log(e);
            return;
        }
    }

    const LoadOrders = async (pagenum, orderby, inc, overrides = {}) => {
        if (invalidSearch) return;

        const { keyword: kw = keyword, status: st = status, dateFrom: df = dateFrom, dateTo: dt = dateTo, pageResults: pr = pageResults, } = overrides;

        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const data = {
                keyword: kw,
                status: st,
                //dateFrom: df ? formatDateMMDDYYYY(new Date(df)) : null,
                //dateTo: dt ? formatDateMMDDYYYY(new Date(dt)) : null,
                dateFrom: df ? formatDateMMDDYYYY(new Date(df)) : '',
                dateTo: dt ? formatDateMMDDYYYY(new Date(dt)) : '',
                orderBy: orderby,
                inc: inc,
                dealerId: user.dealerID,
                pageNum: pagenum,
                count: pr,
                searchType: searchType,
                userKey: user.userKey
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetOrders", requestOptions);
            if (response.status !== 200) {
                handleClosePop();
                return;
            }
            const orders = await response.json();
            setOrderItems(orders);
            setResultsLength(orders[0]?.totalOrders ?? 0);
            handleClosePop();
            setErrorMessage('');
            setFirstLoad(false);
            localStorage.setItem(
                "orderSearch",
                JSON.stringify({
                    keyword,
                    status,
                    dateFrom,
                    dateTo,
                    dateFromInput,
                    dateToInput,
                    pagenum,
                    count: pageResults
                })
            );
            const dataDate = {
                label: user.dealerID,
                value: '1'
            }
            const requestOptionsDate = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(dataDate)
            };
            const responseDate = await fetch("kdealer/GetLastCallAPIDate", requestOptionsDate);
            if (responseDate.status === 200) {
                setLastUpdatedDate(await responseDate.text());
            }

        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'status') {
            setStatus(value);
        } else if (name === 'dateFrom' || name === 'dateTo') {
            const ref = name === 'dateFrom' ? dateFromRef : dateToRef;
            const inputEl = ref.current;
            const start = inputEl.selectionStart;
            const end = inputEl.selectionEnd;

            const masked = formatMaskedDate(value);

            if (name === 'dateFrom') {
                setDateFromInput(masked);
            } else {
                setDateToInput(masked);
            }

            const parsed = parseMaskedDate(masked);
            if (parsed) {
                if (name === 'dateFrom') setDateFrom(parsed);
                else setDateTo(parsed);
            } else {
                if (name === 'dateFrom') {
                    setDateFrom(null);
                } else {
                    setDateTo(null);
                }
            }

            requestAnimationFrame(() => {
                const newPos = calculateNewCaretPosition(value, masked, start);
                inputEl.setSelectionRange(newPos, newPos);
            });
        } else if (name === 'tempPage') {
            setTempPage(value);
        }
    }

    const dateFromRef = useRef(null);
    const dateToRef = useRef(null);

    const calculateNewCaretPosition = (oldValue, newValue, oldPos) => {
        if (newValue.length < oldValue.length) {
            return Math.max(oldPos - 1, 0);
        }

        if (newValue[oldPos] === "/") {
            return oldPos + 1;
        }

        return oldPos;
    }

    const handleFromChange = (newFrom) => {
        setDateFrom(newFrom);
        setDateFromInput(formatDate(newFrom));
        setShowFromCal(false);
    }

    const handleToChange = (newTo) => {
        setDateTo(newTo);
        setDateToInput(formatDate(newTo));
        setShowToCal(false);
    }

    const formatMaskedDate = (value) => {
        const digits = value.replace(/\D/g, "").slice(0, 8);

        let mm = digits.slice(0, 2);
        let dd = digits.slice(2, 4);
        let yyyy = digits.slice(4, 8);

        let formatted = mm;
        if (dd) formatted += "/" + dd;
        if (yyyy) formatted += "/" + yyyy;

        return formatted;
    }

    const parseMaskedDate = (str) => {
        const [mm, dd, yyyy] = str.split("/");
        if (mm?.length === 2 && dd?.length === 2 && yyyy?.length === 4) {
            if (!isValidDate(yyyy, mm, dd)) {
                setErrorMessage('Please enter a valid date');
                setInvalidSearch(true);
                return null;
            }

            if (Number(yyyy) < MIN_YEAR) {
                setErrorMessage(`Year must be ${MIN_YEAR} or later`);
                setInvalidSearch(true);
                return null;
            }

            const parsedDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));

            if (parsedDate > MAX_DATE) {
                setErrorMessage('Date cannot be in the future');
                setInvalidSearch(true);
                return null;
            }

            /*const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));*/
            setInvalidSearch(false);
            setErrorMessage('');
            return parsedDate;
        }
        return null;
    }

    const isValidDate = (year, month, day) => {
        const d = new Date(year, month - 1, day);

        return (
            d.getFullYear() === Number(year) &&
            d.getMonth() === Number(month) - 1 &&
            d.getDate() === Number(day)
        );
    }

    const handleSearchClick = async () => {
        try {
            setShowToCal(false);
            setShowFromCal(false);

            if (!isConfirmationLink) {
                //if (!dateFrom) {
                //    setErrorMessage('Please enter a Date From value.')
                //    return;
                //}

                //if (!dateTo) {
                //    setErrorMessage('Please enter a Date To value.')
                //    return;
                //}

                const from = normalize(new Date(dateFrom));
                const to = normalize(new Date(dateTo));
                const diffInDays = (to - from) / (24 * 60 * 60 * 1000);

                //if (diffInDays > 90) {
                //    setErrorMessage("Please enter a date range no bigger than 90 days.");
                //    return;
                //}

                LoadOrders(1, '', false);
            } else {
                LoadOrders(1, '', false);
                setIsConfirmationLink(false);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleReturnClick = (e, orderID, exchange) => {
        try {
            if (exchange) {
                navigate('/creditrequest', { state: { id: orderID, exchange: true } });
            } else {
                navigate('/creditrequest', { state: { id: orderID } });
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleDuplicateClick = async (e, orderID) => {
        try {
            CheckSession();
            handlePop();
            const user = GetCoockie();
            const response = await fetch("kdealer/GetOrderDetail/" + orderID + "/2/" + user.userKey + "/" + user.dealerID);
            if (response.status !== 200) {
                setErrorMsg('There was an error while attempting to duplicate your order. Please try again later.')
                handleErrorModalShow();
                return;
            }
            const items = await response.json();
            const skuqty = [];
            items.items.forEach(element => {
                skuqty.push({
                    sku: element.sku,
                    qty: element.qty + element.boQty
                });
            });
            let orderType = "1";
            if (items.orderType === "Emergency Order") {
                orderType = "2"
            } else if (items.orderType === "Stocking Order") {
                orderType = "3"
            }
            const res = await GetSKUDetailGlb(skuqty, orderType, items.orderName, items.shipTo.dealerID);
            if (res && res.cart) {
                UpdateShoppingCart(res.cart, setShoppingCart);
                navigate('/neworder');
            }
            else if (res && res.error) {
                //error message
            }

        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    };

    const handleCancelClick = async (e, orderID) => {
        try {
            CheckSession();
            handlePop();
            const user = GetCoockie();
            const data = {
                label: user.dealerID,
                value: orderID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/CancelOrder", requestOptions);
            if (response.status !== 200) {
                setErrorMsg('There was an error while attempting to cancel your order. Please try again later.')
                handleErrorModalShow();
                return;
            }
            window.location.reload(false);
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    };

    const loadOptions = async (orderID, orderStatus) => {
        if (userInfo?.loginType === 5) {
            return;
        }

        if (returnableOrders.has(orderID)) {
            return;
        }
      
        try {
            CheckSession();
            handlePop();
            const user = GetCoockie();
            const resOrderDetail = await fetch("kdealer/GetOrderDetail/" + orderID + "/2/" + user.userKey + "/" + user.dealerID);
            if (resOrderDetail.status !== 200) {
                console.log('cannot get order detail');
            }
            if (orderStatus !== "Shipped" && orderStatus !== "Partial Ship") {
                return;
            }
            const data = {
                label: user.dealerID,
                value: orderID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/CheckIfOrderReturnable", requestOptions);
            if (response.status !== 200) {
                setErrorMsg('There was an error while attempting to get the details of your order. Please try again later.')
                handleErrorModalShow();
                return;
            }
            const res = await response.text();
            if (res === "1") {
                setReturnableOrders(prev => {
                    const updated = new Map(prev);
                    updated.set(orderID, true);
                    return updated;
                });
            } else {
                setReturnableOrders(prev => {
                    const updated = new Map(prev);
                    updated.set(orderID, false);
                    return updated;
                });
            }
            
        } catch (e) {
            console.log(e);
        } finally {
            handleClosePop();
        }
    }

    const handleRefreshOrders = async () => {
        const user = GetCoockie();
        if (!user) return;

        try {
            handlePop();
            const data = {
                dealerID: user.dealerID,
                userKey: user.userKey,
                from: 2
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/SynchOrder", requestOptions);
            if (response.status !== 200) {
                //error message
                setErrorMessage('There was an error while attempting to update orders. Please try again later.');
                handleClosePop();
            } else {
                LoadOrders(1, '', false);
            }
        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }

    const handlePageClick = (input) => {
        const pageIndex = typeof input === "number" ? input : input.selected;
        setCurrentPage(pageIndex);
        LoadOrders(pageIndex + 1, '', false);
    };

    const changePageResults = () => {
        if (tempPage && tempPage > 0 && tempPage < 1000) {
            const newSize = Number(tempPage) || 1; // basic safety 
            setPageResults(newSize);
            setCurrentPage(0);
        }
    };

    useEffect(() => {
        if (!restoredSearch) return;
        if (!firstLoad) {
            LoadOrders(1, '', false);
        }
    }, [pageResults])

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    return (
        <>
            <Container className="checkout-container main-container dealer-section min-height-spacing-lg">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">{t("Navigation.OrderHistory")}</h1>
                    </Col>
                    <Col className="checkout-title-under">
                        {/*<Row className="excel-row">*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Orders</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*    <Col>*/}
                        {/*        <div className="icons-row clickable">*/}
                        {/*            <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />*/}
                        {/*            <p className="mb-0 underline">Excel Order Items</p>*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row className="gy-3">
                                    <Col lg={3} md={6}>
                                        <FloatingLabel label="Keyword" className="mb-4">
                                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />
                                        </FloatingLabel>
                                    </Col>

                                    <Col lg={3} md={6}>
                                        <FloatingLabel label="Order Status" className="mb-4">
                                            <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">
                                                <option value={''}>All</option>
                                                {
                                                    OrderStatusList && OrderStatusList.map((item, index) => (
                                                        <option key={item.value} value={item.value}>{item.label}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Col>

                                    <Col lg={3} md={6}>
                                        <Row className="g-2">
                                            <Col sm={9}>                                                
                                                <FloatingLabel label="Date From" className="mb-4">
                                                    <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFromInput} className={'form-control'} onChange={handleChange} name="dateFrom" ref={dateFromRef} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={2}>
                                                <div onClick={() => setShowFromCal((prev) => !prev)} className="calendar-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
                                                        <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                                        <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                                    </svg>
                                                </div>
                                            </Col>
                                        </Row>
                                        {showFromCal &&
                                            <Row>
                                                <Col sm={12}>
                                                    <Calendar value={dateFrom} onChange={handleFromChange} minDate={new Date(2000, 0, 1)} maxDate={new Date()} />
                                                </Col>
                                            </Row>
                                        }
                                    </Col>

                                    <Col lg={3} md={6}>
                                        <Row className="g-2">
                                            <Col sm={9}>
                                                <FloatingLabel label="Date To" className="mb-4">
                                                    <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateToInput} className={'form-control'} onChange={handleChange} name="dateTo" ref={dateToRef} />
                                                </FloatingLabel>
                                            </Col>
                                            <Col sm={2}>
                                                <div onClick={() => setShowToCal((prev) => !prev)} className="calendar-holder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar3" viewBox="0 0 16 16">
                                                        <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                                                        <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                                    </svg>
                                                </div>
                                            </Col>
                                        </Row>
                                        {showToCal &&
                                            <Row>
                                                <Col sm={12}>
                                                    <Calendar value={dateTo} onChange={handleToChange} minDate={new Date(2000, 0, 1)} maxDate={new Date()} />
                                                </Col>
                                            </Row>
                                        }
                                    </Col>
                                </Row>

                                <Row className="gy-3">
                                    <Col sm={6}>
                                        <div className="default-row mt-2">
                                            <p>Last Updated: {lastUpdatedDate ? lastUpdatedDate : ''}</p>

                                            <p className="clickable underline green-text ml-4" onClick={handleRefreshOrders}>Refresh</p>
                                        </div>
                                    </Col>

                                    <Col lg={{ offset: 2 }} md={{ offset: 1 }} className="text-right" style={{ alignSelf: 'center' }}>
                                        <p className="clickable underline green-text" onClick={ResetSearch}>Reset Search</p>
                                    </Col>

                                    <Col className="text-right mb-3">
                                        <Button variant="secondary" onClick={handleSearchClick}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SEARCH
                                        </Button>
                                    </Col>
                                </Row>

                                {errorMessage &&
                                    <Row>
                                        <Col sm={12} className="text-center">
                                            <p className="red">{errorMessage}</p>
                                        </Col>
                                    </Row>    
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-5 mb-4">
                    <Col sm={12}>
                        {!firstLoad ?
                            <Card className="">
                                <Card.Body>
                                    <Row className="table-legend text-center">
                                        <Col sm={12}>
                                            {/*<div className="table-legend-section">*/}
                                            {/*    <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>*/}
                                            {/*    <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>*/}
                                            {/*    <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>*/}
                                            {/*</div>*/}
                                            <div className="table-legend-section">
                                                <span className="svg-holder"><img src="../../../Images/Allocated.svg" alt="" className="" /> Allocated</span>
                                                {userInfo?.loginType === 5 &&
                                                    <span className="svg-holder"><img src="../../../Images/AllocationProcessing.svg" alt="" className="" /> Allocation Processing</span>
                                                }
                                                <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                                {userInfo?.loginType !== 5 &&
                                                    <>
                                                        <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                                        <span className="svg-holder"><img src="../../../Images/icon-exchangeable.svg" alt="Exchange" /> Exchangeable</span>
                                                    </>
                                                }
                                                <span className="svg-holder"><img src="../../../Images/processing.svg" alt="" className="" /> Processing</span>
                                                <span className="svg-holder"><img src="../../../Images/AllocatedExchange.svg" alt="" className="" style={{ width: '27.5px' }} /> Allocated Exchange</span>
                                                <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                                <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                            </div>
                                            {/*<div className="table-legend-section">*/}
                                            {/*</div>*/}
                                        </Col>
                                    </Row>

                                    <PaginationBar
                                        resultsLength={resultsLength}
                                        pageCount={pageCount}
                                        currentPage={currentPage}
                                        pageResults={pageResults}
                                        tempPage={tempPage}
                                        onTempPageChange={handleChange}
                                        onPageResultsChange={changePageResults}
                                        onPageChange={handlePageClick}
                                    />

                                    <Row>
                                        <Col sm={12} className={currentItems.length > 2 ? "order-table" : "order-table no-scroll-lg"}>
                                            <Table hover responsive className="compact-table">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>ORDER #</th>
                                                        <th>ORDER <br /> DATE</th>
                                                        <th>ORDER <br /> TYPE</th>
                                                        {/*<th>ORDERED BY</th>*/}
                                                        <th>SHIP <br /> METHOD</th>
                                                        <th>STATUS</th>
                                                        <th>TOTAL <br /> ITEMS</th>
                                                        <th>TOTAL</th>
                                                        {userInfo?.loginType !== 5 && 
                                                            <th>EXCH.</th>
                                                        }
                                                        <th width="11%"></th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentItems && currentItems.map((item, index) => (
                                                        <tr className="" key={item.orderID + index}>
                                                            <td>{(currentPage * pageResults) + index + 1}</td>
                                                            <td>
                                                                <table className="inner-table">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="bold">Ord #</td>
                                                                            <td className="bold">{item.orderID}</td>
                                                                        </tr>
                                                                        {/*<tr>*/}
                                                                        {/*    <td>Ref #</td>*/}
                                                                        {/*    <td>{item.refID}</td>*/}
                                                                        {/*</tr>*/}
                                                                        <tr>
                                                                            <td>Name</td>
                                                                            <td>{item.orderName}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                            <td>{item.orderDate}</td>
                                                            <td>{item.orderType}</td>
                                                            {/*<td>{item.orderById} <br /> {item.orderByName}</td>*/}
                                                            <td>{item.shipMethod}</td>
                                                            <td className="table-img"> <span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>
                                                            <td>{item.totalItems}</td>
                                                            <td>{FormatCurrency(item.total)}</td>
                                                            {userInfo?.loginType !== 5 &&
                                                                <td>
                                                                    {item.exchangable &&
                                                                        <span className="svg-holder small-svg clickable" onClick={(e) => handleReturnClick(e, item.orderID, true)}>
                                                                            <img src="../../../Images/icon-exchangeable.svg" alt="Exchange" style={{ height: '30px' }} />
                                                                        </span>
                                                                    }
                                                                </td>
                                                            }
                                                            <td>
                                                                <Button variant="primary" className="btn-maintain" onClick={() => handleDetailsModalShow(item)}>
                                                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                    </svg>
                                                                    VIEW
                                                                </Button>
                                                            </td>
                                                            <td ref={dropdownRef} style={{ position: activeRow === item.refID ? 'absolute' : 'static' }}>
                                                                <DropdownButton
                                                                    variant="outline-dark"
                                                                    title="Actions"
                                                                    id="input-group-dropdown-1"
                                                                    onClick={() => loadOptions(item.orderID, item.status)}
                                                                >
                                                                    <Dropdown.Item onClick={(e) => handleDuplicateClick(e, item.orderID)} ><span className="bold">Duplicate Order</span></Dropdown.Item>
                                                                    {(item.exchangable && userInfo?.loginType !== 5) &&
                                                                        <Dropdown.Item onClick={(e) => handleReturnClick(e, item.orderID, true)}><span className="bold">Exchange</span></Dropdown.Item>
                                                                    }
                                                                    {returnableOrders.get(item.orderID) &&
                                                                        <Dropdown.Item onClick={(e) => handleReturnClick(e, item.orderID, false)}><span className="bold">Return</span></Dropdown.Item>
                                                                    }
                                                                    {(item.status === 'Allocated' || item.status === 'Allocation Exchange' || item.status === 'Back Ordered') && <Dropdown.Item onClick={(e) => handleCancelClick(e, item.orderID)}><span className="bold">Cancel Order</span></Dropdown.Item>}
                                                                </DropdownButton>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>

                                    <PaginationBar
                                        resultsLength={resultsLength}
                                        pageCount={pageCount}
                                        currentPage={currentPage}
                                        pageResults={pageResults}
                                        tempPage={tempPage}
                                        onTempPageChange={handleChange}
                                        onPageResultsChange={changePageResults}
                                        onPageChange={handlePageClick}
                                    />
                                </Card.Body>
                            </Card>
                        :
                            <Card className="">
                                <Card.Body>
                                    <Row>
                                        <Col sm={12} className="text-center">
                                            <p className="bold mt-5 mb-5 svg-carat">
                                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                    <path transform="rotate(-90 8 8)" d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                </svg>
                                                Initiate a search above to view results
                                            </p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        }
                    </Col>
                </Row>

            </Container>

            <FooterDealer />

            <Modal show={errorModal} onHide={handleErrorModalHide} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>ERROR</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>{errorMsg}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={12} className="text-right">
                            <Button variant="secondary" onClick={handleErrorModalHide}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CLOSE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>

            <HistoryDetail show={showDetailsModal} handleClose={handleDetailsModalClose} order={selectedOrder} userInfo={userInfo} historyType={historyType} />
        </>
    );
}